import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {
    GuideAudioProvider,
    GuidePreferencesProvider,
    GuideStateApiProvider,
} from "@repo/guide-core";
import {doNotTranslateYet} from "@repo/i18n";

import KhanmigoSettingsForm from "./khanmigo-settings-form.tsx";

const KhanmigoSettings = () => {
    return (
        <GuideStateApiProvider>
            <GuidePreferencesProvider>
                <GuideAudioProvider>
                    <View
                        style={{gap: sizing.size_320}}
                        role="region"
                        aria-label={doNotTranslateYet`Khanmigo settings`}
                    >
                        <HeadingSmall tag="h2">{doNotTranslateYet`Preferences`}</HeadingSmall>
                        <KhanmigoSettingsForm />
                    </View>
                </GuideAudioProvider>
            </GuidePreferencesProvider>
        </GuideStateApiProvider>
    );
};

export default React.memo(KhanmigoSettings);
